import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const AssignmentsPageContainer = styled.div`
  display: flex;
  height: calc(100% - ${pxToRem(24)});
  margin: ${pxToRem(12)};
`;

export const ContentWrapper = styled.div`
  flex: 1;
  margin-left: 0;
  background: white;
  border-radius: ${pxToRem(16)};
  box-shadow: 0px ${pxToRem(9)} ${pxToRem(14.5)} rgba(0, 0, 0, 0.06),
    0px 0px ${pxToRem(6)} rgba(31, 10, 53, 0.05);
  padding: ${pxToRem(32)} ${pxToRem(25)};
  box-sizing: border-box;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${pxToRem(32)};
`;

export const Title = styled.h1`
  font-size: ${pxToRem(32)};
  font-weight: 700;
  color: rgb(31, 10, 53);
`;

export const ButtonWrapper = styled.div``;

export const FileLinkContainer = styled.div`
  display: inline-flex;
  flex-direction: row;
  gap: ${pxToRem(8)};
  align-items: center;
  border: ${pxToRem(1)} solid rgb(226, 226, 226);
  border-radius: ${pxToRem(8)};
  background: rgb(250, 250, 250);
  padding: ${pxToRem(4)};
  padding-left: ${pxToRem(8)};
  padding-right: ${pxToRem(8)};
  width: fit-content;
`;

export const BaseLinkItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${pxToRem(24)};
  height: ${pxToRem(24)};
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.7;
  }
  & img {
    margin: 0;
  }
`;


export const ButtonsContainer = styled.div`
  display: flex;
  gap: ${pxToRem(30)};
  align-items: center;
`;